import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';

const MainWrapper = styled.div`
  background-color: ${color.light};
  border: solid 1px ${color.gainsboro};
  margin-bottom: 20px;
`;

const TitleWrapper = styled.div`
  padding: 12px 20px;
  border-bottom: solid 1px ${color.gainsboro};

  h2 {
    margin: 0;
    font-size: 16px;
    color: ${color.black};
  }
`;

const BodyWrapper = styled.div`
  padding: 12px 20px;
`;

const ReadMore = styled.a`
  color: ${color.primary};
`;

export { MainWrapper, TitleWrapper, BodyWrapper, ReadMore };
